import React from 'react';
import cn from 'classnames';

const LinkPanel = (props) => {

    return (
        <div 
            onClick={props.onClick}
            className={cn(`ntx-link-panel ntx-modal-body-column-border ${props.className}`)}
        >
            <div 
                className={cn('d-flex flex-column align-items-center')}
            >
                {props.image && 
                    <img 
                        src={props.image} 
                        className={cn('img-fluid')}
                        alt={props.alt}
                    />
                }
                
                {props.caption && 
                    <span className={cn('ntx-link-panel-caption')}>
                        {props.caption}
                    </span>
                }
                
                {props.description &&
                    <span className={cn('ntx-link-panel-description')} 
                        dangerouslySetInnerHTML={{ __html: props.description }}
                    />
                }
            </div>
        </div>
    );

};

export default LinkPanel;